<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    overlayCloses: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    document.querySelector('body').classList.toggle('modal-active')
  },

  methods: {
    onClickOverlay() {
      if (this.overlayCloses) {
        this.$emit('close')
      }
    },

    onClickClose() {
      this.$emit('close')
    },
  },
}
</script>

<template>
  <div
    class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center"
  >
    <div
      class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
      @click="onClickOverlay"
    ></div>

    <div
      class="modal-container bg-white w-300 lg:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto"
      style="max-height: 60vh"
    >
      <div class="modal-content py-4 text-left px-6">
        <div class="flex justify-between items-center pb-3">
          <p class="text-xl font-bold">{{ title }}</p>
          <div class="modal-close cursor-pointer z-50" @click="onClickClose">
            <svg
              class="fill-current text-black"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
              ></path>
            </svg>
          </div>
        </div>

        <div class="my-4">
          <slot />
        </div>

        <div class="flex justify-end pt-2">
          <base-btn-text class="p-3" @click="onClickClose">
            Uždaryti
          </base-btn-text>
          <slot name="buttons" />
        </div>
      </div>
    </div>
  </div>
</template>
